module.exports = __webpack_public_path__ + "static/media/pdp_paperEggshell.03697f9d.jpg";